import * as React from 'react';
import { styled } from '@glitz/react';
import { secondaryLight } from 'svenssons/shared/theme';
import Image from 'webapp/components/image';
import { addNavigationEventToDataLayer } from 'webapp/tracking/events/main-navigation';
import { bareListDecorator } from 'webapp/decorators/list';
import Link from 'webapp/components/Link';

type PropType = {
  menu: NordicNest.Api.CfMenuApiModel;
  selectedCategory: NordicNest.Api.MenuItemApiModel;
};

export function MenuHighlights({ menu, selectedCategory }: PropType): React.JSX.Element {
  return (
    <PrimaryLinks>
      <CurrentCategory {...selectedCategory.link} />
      <HighlightedList>
        {menu?.secondaryLinks.map(l => (
          <li key={l.link.to}>
            <PrimaryItem
              {...l.link}
              onClick={() => addNavigationEventToDataLayer({ ...l, menu_type: 'side', menu_category: 'level_0' })}
            />
          </li>
        ))}
      </HighlightedList>
      {selectedCategory.icon && <Icon image={{ url: selectedCategory.icon?.url }} />}
    </PrimaryLinks>
  );
}

const linkHoverDecorator = {
  ':hover': {
    textDecoration: 'underline',
  },
};

const CurrentCategory = styled(Link, linkHoverDecorator, {
  fontSize: 24,
  fontWeight: 'bold',
  marginBottom: t => t.spacing.xs,
});

const PrimaryLinks = styled.div({
  display: 'flex',
  flexDirection: 'column',
  padding: { x: t => t.spacing.xxxl, y: t => t.sharedSpacing.xxl },
  backgroundColor: secondaryLight,
  alignItems: 'flex-start',
});

const Icon = styled(Image, {
  fontSize: t => t.fontSize.xl,
  marginTop: t => t.spacing.s,
  maxHeight: 40,
});

const List = styled.ul(bareListDecorator, {
  display: 'flex',
  flexDirection: 'column',
  breakInside: 'avoid',
});

const HighlightedList = styled(List, {
  gap: t => t.spacing.xs,
});

const PrimaryItem = styled(Link, linkHoverDecorator, {
  display: 'inline-block',
  fontFamily: 'charter',
  textTransform: 'uppercase',
});
